/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_SideInputs */

const en_us2_search_field_side = /** @type {(inputs: Search_Field_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominant side`)
};

const pt_br2_search_field_side = /** @type {(inputs: Search_Field_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lado dominante`)
};

const es_419_search_field_side = /** @type {(inputs: Search_Field_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lado dominante`)
};

const pt_pt2_search_field_side = /** @type {(inputs: Search_Field_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lado dominante`)
};

const fr_fr2_search_field_side = /** @type {(inputs: Search_Field_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Côté dominant`)
};

const de_de2_search_field_side = /** @type {(inputs: Search_Field_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominante Seite`)
};

const it_it2_search_field_side = /** @type {(inputs: Search_Field_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lato dominante`)
};

/**
* | output |
* | --- |
* | "Dominant side" |
*
* @param {Search_Field_SideInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_side = /** @type {((inputs?: Search_Field_SideInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_SideInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_side(inputs)
	if (locale === "es-419") return es_419_search_field_side(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_side(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_side(inputs)
	if (locale === "de-DE") return de_de2_search_field_side(inputs)
	if (locale === "it-IT") return it_it2_search_field_side(inputs)
	return en_us2_search_field_side(inputs)
});
export { search_field_side as "search.field_side" }